<template>
  <v-card elevation="0">
    <v-row class="pa-0 ma-0">
      <v-col xl="8" lg="9" md="9" sm="10" cols="12">
        <mb-select
          v-model="val"
          :items="family"
          itemText="name"
          itemValue="id"
          returnObject
          name="patient"
          label="Paciente"
          :loading="loading"
          @input="$emit('input', val)"
        />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import MbSelect from '@/components/general/inputs/MbSelect';

export default {
  props: {
    value: {
      type: Object,
    },
  },
  data: () => ({
    val: null,
    loading: false,
    family: [],
  }),
  computed: {
    user() {
      return this.$store.getters['auth/getUser'];
    },
  },
  created() {
    this.val = this.value;
    this.getFamily();
  },
  methods: {
    getFamily() {
      this.loading = true;
      if (this.user) {
        this.$store.dispatch('patientDependents/getFamily', this.user.id)
          .then((family) => {
            this.family = family;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
  components: {
    MbSelect,
  },
};
</script>
